import type { TFunction } from 'i18next';
import type { CustomerUsageMetric, CustomerUsagePeriod } from '../Constants/VOSS/usageTypes';

const monthKeys = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export function getInitialPeriodIndex(metric: CustomerUsageMetric | null | undefined): number {
    if (!metric) return 0;
    if (metric.periods.length === 0) return 0;
    const i = metric.periods.findIndex(p => p.isCurrent);
    return i >= 0 ? i : metric.periods.length - 1;
}

export function formatPeriod(period: CustomerUsagePeriod | null | undefined, t: TFunction): string {
    if (!period) return String(t('vossusage.period.unknown'));

    const { year, month } = period;
    if (year !== null && month !== null && month >= 1 && month <= 12) {
        return `${String(t(`months.${monthKeys[month - 1]}`))} ${year}`;
    }

    const displayName = period.tierPricingGroupDisplayName;
    if (displayName !== null && displayName !== undefined && displayName !== '') {
        return displayName;
    }

    return String(
        t(period.isCurrent ? 'vossusage.period.currentFiscalYear' : 'vossusage.period.earlierFiscalYear'),
    );
}
